export const BASE_URL = 'https://nodeapi.nurutama.id';
//http://localhost:3000/
//https://nodeapi.nurutama.id
